import BillingPricingComponent from "./component"

const actionSelector = "[data-billing-pricing-plan-action]"
const radioSelector = "input[type=radio]"

class BillingPricingPlan extends BillingPricingComponent {
  static get selector() {
    return "[data-billing-pricing-plan]"
  }

  init() {
    this.selected = this.element.dataset.billingPricingPlanPreselected === "true"

    this.element.addEventListener("click", (e) => {
      // Plan can be changed from other pricing components, so we let pricing
      // object always orchestrate the change.
      this.pricing.setPlan(this)
    })

    this.initialized()
  }

  valid() {
    return super.valid() && this.id && this.recurring
  }

  select() {
    if (this.selected) {
      return
    }

    this.selected = true
    this.radioElement.click()

    // border
    this.element.classList.remove("ring-1", "ring-gray-200")
    this.element.classList.add("ring-2", "ring-blue-600")

    // action
    this.actionElement.classList.remove("text-blue-600", "ring-1", "ring-inset", "ring-blue-200", "hover:ring-blue-300")
    this.actionElement.classList.add("bg-blue-600", "text-white", "shadow-sm", "hover:bg-blue-500")

    // action text
    const text = this.actionElement.dataset.billingPricingPlanSelectedActionText
    if (text) {
      this.actionElement.textContent = text
    }
  }

  unselect() {
    this.selected = false

    // border
    this.element.classList.remove("ring-2", "ring-blue-600")
    this.element.classList.add("ring-1", "ring-gray-200")

    // action
    this.actionElement.classList.remove("bg-blue-600", "text-white", "shadow-sm", "hover:bg-blue-500")
    this.actionElement.classList.add("text-blue-600", "ring-1", "ring-inset", "ring-blue-200", "hover:ring-blue-300")

    // action text
    const text = this.actionElement.dataset.billingPricingPlanUnselectedActionText
    if (text) {
      this.actionElement.textContent = text
    }
  }

  get id() {
    if (this._id === undefined) {
      this._id = this.element.dataset.billingPricingPlan
    }
    return this._id
  }

  get recurring() {
    if (this._recurring === undefined) {
      this._recurring = this.element.dataset.billingPricingPlanRecurring
    }
    return this._recurring
  }

  get actionElement() {
    if (this._actionElement === undefined) {
      this._actionElement = this.element.querySelector(actionSelector)
    }
    return this._actionElement
  }

  get radioElement() {
    if (this._radioElement === undefined) {
      this._radioElement = this.element.querySelector(radioSelector)
    }
    return this._radioElement
  }
}

export default BillingPricingPlan
